import React from "react";
import { useUscSelector } from "../../../redux/store";
import type { UscLabelType } from "../../../utils/labels";
import { useUscLabel, useUscOptionalLabel } from "../../../utils/labels";
import Container from "../styles/atoms/Container";
import * as Styles from "./PageDisclaimers.styles";
import { getPageDisclaimerLabel } from "../../../utils/pdpUtils";

const PageDisclaimers = (): JSX.Element | null => {
    const vehicleType = useUscSelector((state) => state.vehicle.type);
    const financeOption = useUscSelector((state) => state.basket.activeFinanceOption);

    // Static disclaimer title + description, configured in i18n
    const disclaimerTitleLabel = useUscLabel("uscPageDisclaimerTitle");
    const disclaimerLabel = useUscOptionalLabel(getPageDisclaimerLabel(financeOption, vehicleType) as UscLabelType);

    if (!disclaimerLabel) return null;

    return (
        <Styles.Wrapper>
            <Container variant="container">
                <Styles.Content>
                    {disclaimerTitleLabel && <Styles.Title>{disclaimerTitleLabel}</Styles.Title>}
                    <div dangerouslySetInnerHTML={{ __html: disclaimerLabel }} />
                </Styles.Content>
            </Container>
        </Styles.Wrapper>
    );
};

export default PageDisclaimers;
